import i18n from "i18next";

// Translate files
import fr from './fr';

// detect lang with "i18next-browser-languagedetector"
i18n.init({
    resources: {
        fr: {translation: fr},
        // en: {translation: en},
    },
    lng: "fr", // default
    fallbackLng: "fr",
    interpolation: {
        escapeValue: false // react already escapes
    }
});

export const t = (...args) => i18n.t(...args);
export const language = i18n.language;

export default i18n;